/* This file contains utility functions for Exchange betting, that have not yet been JSLinted */

/*global
com,
$
*/

/** returns base combination of multiples based on number of selections and also considering accumulatorThreshold.
    Maximum 15 selections can be added for multiple bets.
 * @param {Object} params
 * @param.selLen {Object} number of selections for multiples
 * @param.accumulatorThreshold {Object} accumulatorThreshold
 * @param.includeSeperateSingles {Object} whether to return Singles
 * @returns {Object} base combination
 */
com.globalbettingexchange.base.getMultiplesBaseCombination = function (params) {
    var selLen = params.selLen;
    var accumulatorThreshold = params.accumulatorThreshold;
    var i, j;
    var includeSeperateSingles = params.includeSeperateSingles;
    var multipleBaseCombination;
    var multiplesBaseConfig = [];

    multiplesBaseConfig[0] = [{
        "name": "Double ({0})",
        "0name": "{0} Double",
        "count": 1,
        "level": 2,
        "legs": [2]
    }];
    multiplesBaseConfig[1] = [{
        "name": "Treble ({0})",
        "0name": "{0} Treble",
        "count": 1,
        "level": 3,
        "legs": [3]
    }, {
        "name": "Double ({0})",
        "0name": "{0} Doubles",
        "count": 3,
        "level": 2,
        "legs": [2]
    }, {
        "name": "Trixie ({0})",
        "count": 4,
        "level": 0,
        "legs": [2, 3]
    }, {
        "name": "Patent ({0})",
        "count": 7,
        "level": 0,
        "legs": [1, 2, 3]
    }];
    multiplesBaseConfig[2] = [{
        "name": "Four Fold ({0})",
        "0name": "{0} Four Fold",
        "count": 1,
        "level": 4,
        "legs": [4]
    }, {
        "name": "Double ({0})",
        "0name": "{0} Doubles",
        "count": 6,
        "level": 2,
        "legs": [2]
    }, {
        "name": "Treble ({0})",
        "0name": "{0} Trebles",
        "count": 4,
        "level": 3,
        "legs": [3]
    }, {
        "name": "Yankee ({0})",
        "count": 11,
        "level": 0,
        "legs": [2, 3, 4]
    }, {
        "name": "Lucky 15 ({0})",
        "count": 15,
        "level": 0,
        "legs": [1, 2, 3, 4]
    }];
    multiplesBaseConfig[3] = [{
        "name": "Five Fold ({0})",
        "0name": "{0} Five Fold",
        "count": 1,
        "level": 5,
        "legs": [5]
    }, {
        "name": "Double ({0})",
        "0name": "{0} Doubles",
        "count": 10,
        "level": 2,
        "legs": [2]
    }, {
        "name": "Treble ({0})",
        "0name": "{0} Trebles",
        "count": 10,
        "level": 3,
        "legs": [3]
    }, {
        "name": "Four Fold ({0})",
        "0name": "{0} Four Folds",
        "count": 5,
        "level": 4,
        "legs": [4]
    }, {
        "name": "Super Yankee ({0})",
        "count": 26,
        "level": 0,
        "legs": [2, 3, 4, 5]
    }, {
        "name": "Lucky 31 ({0})",
        "count": 31,
        "level": 0,
        "legs": [1, 2, 3, 4, 5]
    }];
    multiplesBaseConfig[4] = [{
        "name": "Six Fold ({0})",
        "0name": "{0} Six Fold",
        "count": 1,
        "level": 6,
        "legs": [6]
    }, {
        "name": "Double ({0})",
        "0name": "{0} Doubles",
        "count": 15,
        "level": 2,
        "legs": [2]
    }, {
        "name": "Treble ({0})",
        "0name": "{0} Trebles",
        "count": 20,
        "level": 3,
        "legs": [3]
    }, {
        "name": "Four Fold ({0})",
        "0name": "{0} Four Folds",
        "count": 15,
        "level": 4,
        "legs": [4]
    }, {
        "name": "Five Folds ({0})",
        "0name": "{0} Five Folds",
        "count": 6,
        "level": 5,
        "legs": [5]
    }, {
        "name": "Heinz ({0})",
        "count": 57,
        "level": 0,
        "legs": [2, 3, 4, 5, 6]
    }, {
        "name": "Lucky 63 ({0})",
        "count": 63,
        "level": 0,
        "legs": [1, 2, 3, 4, 5, 6]
    }];

    multiplesBaseConfig[5] = [{
        "name": "Seven Fold ({0})",
        "0name": "{0} Seven Fold",
        "count": 1,
        "level": 7,
        "legs": [7]
    }, {
        "name": "Double ({0})",
        "0name": "{0} Doubles",
        "count": 21,
        "level": 2,
        "legs": [2]
    }, {
        "name": "Treble ({0})",
        "0name": "{0} Trebles",
        "count": 35,
        "level": 3,
        "legs": [3]
    }, {
        "name": "Four Fold ({0})",
        "0name": "{0} Four Folds",
        "count": 35,
        "level": 4,
        "legs": [4]
    }, {
        "name": "Five Folds ({0})",
        "0name": "{0} Five Folds",
        "count": 21,
        "level": 5,
        "legs": [5]
    }, {
        "name": "Six Folds ({0})",
        "0name": "{0} Six Folds",
        "count": 7,
        "level": 6,
        "legs": [6]
    }, {
        "name": "Super Heinz  ({0})",
        "count": 120,
        "level": 0,
        "legs": [2, 3, 4, 5, 6, 7]
    }];

    multiplesBaseConfig[6] = [{
        "name": "Eight Fold ({0})",
        "0name": "{0} Eight Fold",
        "count": 1,
        "level": 8,
        "legs": [8]
    }, {
        "name": "Double ({0})",
        "0name": "{0} Doubles",
        "count": 28,
        "level": 2,
        "legs": [2]
    }, {
        "name": "Treble ({0})",
        "0name": "{0} Trebles",
        "count": 56,
        "level": 3,
        "legs": [3]
    }, {
        "name": "Four Fold ({0})",
        "0name": "{0} Four Folds",
        "count": 70,
        "level": 4,
        "legs": [4]
    }, {
        "name": "Five Folds ({0})",
        "0name": "{0} Five Folds",
        "count": 56,
        "level": 5,
        "legs": [5]
    }, {
        "name": "Six Folds ({0})",
        "0name": "{0} Six Folds",
        "count": 28,
        "level": 6,
        "legs": [6]
    }, {
        "name": "Seven Folds ({0})",
        "0name": "{0} Seven Folds",
        "count": 8,
        "level": 7,
        "legs": [7]
    }, {
        "name": "Goliath ({0})",
        "count": 247,
        "level": 0,
        "legs": [2, 3, 4, 5, 6, 7, 8]
    }];

    multiplesBaseConfig[7] = [{
        "name": "Nine Fold ({0})",
        "0name": "{0} Nine Fold",
        "count": 1,
        "level": 9,
        "legs": [9]
    }, {
        "name": "Double ({0})",
        "0name": "{0} Doubles",
        "count": 36,
        "level": 2,
        "legs": [2]
    }, {
        "name": "Treble ({0})",
        "0name": "{0} Trebles",
        "count": 84,
        "level": 3,
        "legs": [3]
    }, {
        "name": "Four Fold ({0})",
        "0name": "{0} Four Folds",
        "count": 126,
        "level": 4,
        "legs": [4]
    }, {
        "name": "Five Folds ({0})",
        "0name": "{0} Five Folds",
        "count": 126,
        "level": 5,
        "legs": [5]
    }, {
        "name": "Six Folds ({0})",
        "0name": "{0} Six Folds",
        "count": 84,
        "level": 6,
        "legs": [6]
    }, {
        "name": "Seven Folds ({0})",
        "0name": "{0} Seven Folds",
        "count": 36,
        "level": 7,
        "legs": [7]
    }, {
        "name": "Eight Fold ({0})",
        "0name": "{0} Eight Fold",
        "count": 9,
        "level": 8,
        "legs": [8]
    }];

    multiplesBaseConfig[8] = [{
        "name": "Ten Fold ({0})",
        "0name": "{0} Ten Fold",
        "count": 1,
        "level": 10,
        "legs": [10]
    }, {
        "name": "Double ({0})",
        "0name": "{0} Doubles",
        "count": 45,
        "level": 2,
        "legs": [2]
    }, {
        "name": "Treble ({0})",
        "0name": "{0} Trebles",
        "count": 120,
        "level": 3,
        "legs": [3]
    }, {
        "name": "Four Fold ({0})",
        "0name": "{0} Four Folds",
        "count": 210,
        "level": 4,
        "legs": [4]
    }, {
        "name": "Five Folds ({0})",
        "0name": "{0} Five Folds",
        "count": 252,
        "level": 5,
        "legs": [5]
    }, {
        "name": "Six Folds ({0})",
        "0name": "{0} Six Folds",
        "count": 210,
        "level": 6,
        "legs": [6]
    }, {
        "name": "Seven Folds ({0})",
        "0name": "{0} Seven Folds",
        "count": 120,
        "level": 7,
        "legs": [7]
    }, {
        "name": "Eight Fold ({0})",
        "0name": "{0} Eight Fold",
        "count": 45,
        "level": 8,
        "legs": [8]
    }, {
        "name": "Nine Fold ({0})",
        "0name": "{0} Nine Fold",
        "count": 10,
        "level": 9,
        "legs": [9]
    }];

    multiplesBaseConfig[9] = [{
        "name": "Eleven Fold ({0})",
        "0name": "{0} Eleven Fold",
        "count": 1,
        "level": 11,
        "legs": [11]
    }, {
        "name": "Double ({0})",
        "0name": "{0} Doubles",
        "count": 55,
        "level": 2,
        "legs": [2]
    }, {
        "name": "Treble ({0})",
        "0name": "{0} Trebles",
        "count": 165,
        "level": 3,
        "legs": [3]
    }, {
        "name": "Nine Fold ({0})",
        "0name": "{0} Nine Fold",
        "count": 55,
        "level": 0,
        "legs": [9]
    }, {
        "name": "Ten Fold ({0})",
        "0name": "{0} Ten Fold",
        "count": 11,
        "level": 0,
        "legs": [10]
    }];

    multiplesBaseConfig[10] = [{
        "name": "Twelve Fold ({0})",
        "0name": "{0} Twelve Fold",
        "count": 1,
        "level": 12,
        "legs": [12]
    }, {
        "name": "Double ({0})",
        "0name": "{0} Doubles",
        "count": 66,
        "level": 2,
        "legs": [2]
    }, {
        "name": "Treble ({0})",
        "0name": "{0} Trebles",
        "count": 220,
        "level": 3,
        "legs": [3]
    }, {
        "name": "Ten Fold ({0})",
        "0name": "{0} Ten Fold",
        "count": 66,
        "level": 0,
        "legs": [10]
    }, {
        "name": "Eleven Fold ({0})",
        "0name": "{0} Eleven Fold",
        "count": 12,
        "level": 0,
        "legs": [11]
    }];

    multiplesBaseConfig[11] = [{
        "name": "Thirteen Fold ({0})",
        "0name": "{0} Thirteen Fold",
        "count": 1,
        "level": 13,
        "legs": [13]
    }, {
        "name": "Double ({0})",
        "0name": "{0} Doubles",
        "count": 78,
        "level": 2,
        "legs": [2]
    }, {
        "name": "Eleven Fold ({0})",
        "0name": "{0} Eleven Fold",
        "count": 78,
        "level": 0,
        "legs": [11]
    }, {
        "name": "Twelve Fold ({0})",
        "0name": "{0} Twelve Fold",
        "count": 13,
        "level": 0,
        "legs": [12]
    }];

    multiplesBaseConfig[12] = [{
        "name": "Fourteen Fold ({0})",
        "0name": "{0} Fourteen Fold",
        "count": 1,
        "level": 14,
        "legs": [14]
    }, {
        "name": "Double ({0})",
        "0name": "{0} Doubles",
        "count": 91,
        "level": 2,
        "legs": [2]
    }, {
        "name": "Twelve Fold ({0})",
        "0name": "{0} Twelve Fold",
        "count": 91,
        "level": 0,
        "legs": [12]
    }, {
        "name": "Thirteen Fold ({0})",
        "0name": "{0} Thirteen Fold",
        "count": 14,
        "level": 0,
        "legs": [13]
    }];

    multiplesBaseConfig[13] = [{
        "name": "Fifteen Fold ({0})",
        "0name": "{0} Fifteen Fold",
        "count": 1,
        "level": 15,
        "legs": [15]
    }, {
        "name": "Double ({0})",
        "0name": "{0} Doubles",
        "count": 105,
        "level": 2,
        "legs": [2]
    }, {
        "name": "Thirteen Fold ({0})",
        "0name": "{0} Thirteen Fold",
        "count": 105,
        "level": 0,
        "legs": [13]
    }, {
        "name": "Fourteen Fold ({0})",
        "0name": "{0} Fourteen Fold",
        "count": 15,
        "level": 0,
        "legs": [14]
    }];

    var numbers = ["", "", "Treble ({0})", "Four Fold ({0})", "Five Fold ({0})", "Six Fold ({0})", "Seven Fold ({0})", "Eight Fold ({0})", "Nine Fold ({0})", "Ten Fold ({0})", "Eleven Fold ({0})", "Twelve Fold ({0})", "Thirteen Fold ({0})", "Fourteen Fold ({0})", "Fifteen Fold ({0})"];
    var nNumbers = ["", "", "{0} Trebles", "{0} Four Folds", "{0} Five Folds", "{0} Six Folds", "{0} Seven Fold", "{0} Eight Fold", "{0} Nine Fold", "{0} Ten Fold", "{0} Eleven Fold", "{0} Twelve Fold", "{0} Thirteen Fold", "{0} Fourteen Fold", "{0} Fifteen Fold"];
    for (i = accumulatorThreshold - 2; i < 9; i += 1) {
        multiplesBaseConfig[i] = [{
            "name": numbers[i + 1],
            "0name": nNumbers[i + 1],
            "count": 1,
            "level": i + 2,
            "legs": multiplesBaseConfig[i][0].legs
        }];
    }

    for (i = 0; i < multiplesBaseConfig.length; i += 1) {
        for (j = 0; j < multiplesBaseConfig[i].length; j += 1) {
            multiplesBaseConfig[i][j].pickedCount = multiplesBaseConfig[i][j].count;
        }
    }

     multipleBaseCombination = multiplesBaseConfig[selLen - 2];
    //add singles
    if (includeSeperateSingles
        && selLen <= 6
        && multipleBaseCombination.length > 1) {

        multipleBaseCombination.splice(1, 0, {
            "name": "Single ({0})",
            "0name": "{0} Single",
            "count": selLen,
            "level": 1,
            "legs": [1]
        });

    }
    return multipleBaseCombination;
};

/** Process bet quotations and returns quotations under appropriate combination which is conveniently
    used later when placing bet.
 * @param {Object} params
 * @param.multiBetSlip {Object} an object with combinations and other information which is storing the state of multiples
 * @param.selections {Object} selections added for multiples
 * @param.quotations {Object} quotations returned from RequestMultipleBetQuotation.ashx
 * @returns {Object} modified multiBetSlip
 */
com.globalbettingexchange.base.processMultipleBetQuotations = function (params) {
    var multiBetSlip = params.multiBetSlip,
        quotations = params.quotations,
        selections = params.selections,
        selLen = selections.length,
        qLen,
        quotation,
        combination,
        i,
        j,
        legWiseCompositeOdds = 0,
        requestedLegsCount = 0,
        currentLeg,
        len = quotations.length,
        combinedLen = multiBetSlip.combinations.length,
        bestOffer,
		legWiseCombination,
        legWiseCombinations = multiBetSlip.legWiseCombinations,
        multiBetSlip = multiBetSlip,
        cumulativeOfferPrice = function (offers, leg) {
            if (offers && offers[0]) {
                legWiseCombinations["leg" + leg].compositeOdds += offers[0].offerPrice;
            }
        },
        inValidLeg = false,
        lowestPrice,
        maxStake,
        allLowestPrice = 0;

    /*
    need to process normal combinations like double,treble etc.
    also need to process special combinations which is a combination of normal combinations.
    special combination is identified by legs requested.
    when more than 1 leg is requested its a special combination.

    state
    compositeOdds
    legWiseCompositeOdds
    maxStake
    inValidLeg
    */

    /*
    below loops throuh quotations and set quotations to corresponding combination.
    since singles combination is not displayed and its used for special combinations combinations and composite odds are also
    save legwise so special combinations can use it when saving.
    */
    for (i = 0; i < len; i += 1) {
        quotation = quotations[i];
        if (quotation && quotation.selections) {
            qLen = quotation.selections.length;
            quotation.cherryPicked = true;
            combination = null;
            //identify combination from its legs.
            for (j = 0; j < combinedLen; j += 1) {
                if (multiBetSlip.combinations[j].legs.length === 1) {//only normal combination
                    if (multiBetSlip.combinations[j].legs[0] === qLen) {
                        combination = multiBetSlip.combinations[j];
                        break;
                    }
                }
            }
            if (combination) {
                combination.quotations.push(quotation);
            }

            if (!legWiseCombinations["leg" + qLen]) {
                legWiseCombinations["leg" + qLen] = {
                    "compositeOdds": 0,
                    "quotations": [],
                    "inValid": false
                };
            }
            legWiseCombinations["leg" + qLen].quotations.push(quotation);

            cumulativeOfferPrice(quotation.offers, qLen);
        }
    }


    /*as singles are not displayed as a combination but used in special combinations
    need to check validity and calcualte maxstake, lowestPrice etc.*/

    if (legWiseCombinations.leg1) {
        inValidLeg = false;
        legWiseCompositeOdds = 0;
        bestOffer = {
            "offerPrice": 0,
            "stake": {
                "amount": 0
            }
        };
        lowestPrice = 0;
        for (j = 0; j < legWiseCombinations.leg1.quotations.length; j += 1) {
            quotation = legWiseCombinations.leg1.quotations[j];
            if (quotation.offers && quotation.offers[0]) {

                if (quotation.cherryPicked) {
                    legWiseCompositeOdds += quotation.offers[0].offerPrice;
                }


                if (quotation.offers[0].offerPrice > bestOffer.offerPrice) {
                    bestOffer = quotation.offers[0];
                }
                if (lowestPrice === 0 || (lowestPrice > 0 && lowestPrice > quotation.offers[0].offerPrice)) {
                    lowestPrice = quotation.offers[0].offerPrice;
                }
            } else {
                inValidLeg = true;
            }
        }
        if (allLowestPrice === 0 || (allLowestPrice > 0 && allLowestPrice > lowestPrice)) {
            allLowestPrice = lowestPrice;
        }
        if (legWiseCombinations.leg1.quotations.length < selLen) {
            inValidLeg = true;
        }
        legWiseCombinations.leg1.inValid = inValidLeg;
        legWiseCombinations.leg1.maxStake = bestOffer.stake.amount;
        legWiseCombinations.leg1.lowestPrice = lowestPrice;
    }

    if (combinedLen > 0) {

        len = multiBetSlip.combinations.length;

        for (i = 0; i < len; i += 1) {

            combination = multiBetSlip.combinations[i];

            //if combination leg included in requested leg. assume its state to 2.

            requestedLegsCount = 0;
            for (j = 0; j < combination.legs.length; j += 1) {
                currentLeg = combination.legs[j];
                if ($.inArray(currentLeg, multiBetSlip.levelsRequested) > -1) {
                    requestedLegsCount += 1;
                }
            }

            if (combination.legs.length === requestedLegsCount) {
                combination.state = 2;
            }

            if (combination.legs.length === 1 && combination.state === 2) {//this is normal combinations
                inValidLeg = false;
                legWiseCompositeOdds = 0;
                bestOffer = {
                    "offerPrice": 0,
                    "stake": {
                        "amount": 0
                    }
                };
                lowestPrice = 0;
                for (j = 0; j < combination.quotations.length; j += 1) {
                    quotation = combination.quotations[j];
                    if (quotation.offers && quotation.offers[0]) {

                        if (quotation.cherryPicked) {
                            legWiseCompositeOdds += quotation.offers[0].offerPrice;
                        }


                        if (quotation.offers[0].offerPrice > bestOffer.offerPrice) {
                            bestOffer = quotation.offers[0];
                        }
                        if (lowestPrice === 0 || (lowestPrice > 0 && lowestPrice > quotation.offers[0].offerPrice)) {
                            lowestPrice = quotation.offers[0].offerPrice;
                        }
                    } else {
                        inValidLeg = true;
                    }
                }
                if (allLowestPrice === 0 || (allLowestPrice > 0 && allLowestPrice > lowestPrice)) {
                    allLowestPrice = lowestPrice;
                }
                if (combination.count > combination.quotations.length) {
                    inValidLeg = true;
                }
                combination.inValid = inValidLeg;
                combination.maxStake = bestOffer.stake.amount;
                combination.compositeOdds = legWiseCompositeOdds;
                combination.isDisabled = false;
                combination.lowestPrice = lowestPrice;
                //in case no ofeers returned
                if (!legWiseCombinations["leg" + combination.legs[0]]) {
                    legWiseCombinations["leg" + combination.legs[0]] = {
                        "compositeOdds": 0,
                        "quotations": [],
                        "inValid": false
                    };
                }

                legWiseCombinations["leg" + combination.legs[0]].inValid = inValidLeg;
                legWiseCombinations["leg" + combination.legs[0]].maxStake = combination.maxStake;
                legWiseCombinations["leg" + combination.legs[0]].lowestPrice = combination.lowestPrice;
            } else {//special combination
                //state
                //check if all levels under this combination is requested for combinations and returned.
                requestedLegsCount = 0;
                legWiseCompositeOdds = 0;
                inValidLeg = false;
                maxStake = 0;
                lowestPrice = 0;

                for (j = 0; j < combination.legs.length; j += 1) {
                    currentLeg = combination.legs[j];
                    if ($.inArray(currentLeg, multiBetSlip.levelsRequested) > -1) {
                        requestedLegsCount += 1;
                        legWiseCombination = multiBetSlip.legWiseCombinations["leg" + currentLeg];
                        legWiseCompositeOdds += legWiseCombination ? legWiseCombination.compositeOdds : 0;
                        //if atleast one leg is invalid it invalidates the whole combination
                        if (!legWiseCombination || multiBetSlip.legWiseCombinations["leg" + currentLeg].inValid) {
                            inValidLeg = true;
                        }
                        if (legWiseCombination && multiBetSlip.legWiseCombinations["leg" + currentLeg].maxStake > maxStake) {
                            maxStake = multiBetSlip.legWiseCombinations["leg" + currentLeg].maxStake;
                        }
                        if (legWiseCombination && lowestPrice === 0 || (lowestPrice > 0 && multiBetSlip.legWiseCombinations["leg" + currentLeg].lowestPrice < lowestPrice)) {
                            lowestPrice = multiBetSlip.legWiseCombinations["leg" + currentLeg].lowestPrice;
                        }
                    }
                }
                if (combination.legs.length === requestedLegsCount) {
                    combination.state = 2;
                    combination.compositeOdds = legWiseCompositeOdds;
                    combination.maxStake = maxStake;
                    combination.lowestPrice = lowestPrice;

                    if (inValidLeg) {
                        combination.inValid = inValidLeg;
                    }
                }
            }

        }
    }
    return multiBetSlip;
};
